.title {
    font-size: 32;
    font-weight: 600;
    color: #303030;
    text-align: center;
}

.alert {
    display: block;
}